import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import Icons from "../../../assets/js/Icons";
import { useEffect } from "react";

export const ShareButtons = ({ open, onClose, url, title }) => {
  useEffect(() => {
    if (open) {
      const script = document.createElement("script");
      script.src = "https://static.addtoany.com/menu/page.js";
      script.async = true;
      document.body.appendChild(script);

      window.a2a_config = window.a2a_config || {};
      window.a2a_config.linkname = title;
      window.a2a_config.linkurl = url;

      setTimeout(() => {
        window.a2a.init_all();
      }, 0);
    }
  }, [open, url, title]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        Share
        <IconButton onClick={onClose} size="small">
          <Icons.Cross />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "12px",
            justifyContent: "center",
            padding: "16px",
          }}
          className="a2a_kit a2a_kit_size_32 a2a_default_style"
          data-a2a-url={url}
          data-a2a-title={title}
        >
          <IconButton component="a" className="a2a_dd" href="https://www.addtoany.com/share"></IconButton>
          <IconButton component="a" className="a2a_button_facebook"></IconButton>
          <IconButton component="a" className="a2a_button_twitter"></IconButton>
          <IconButton component="a" className="a2a_button_linkedin"></IconButton>
          <IconButton component="a" className="a2a_button_whatsapp"></IconButton>
          <IconButton component="a" className="a2a_button_telegram"></IconButton>
          <IconButton component="a" className="a2a_button_email"></IconButton>
          <IconButton component="a" className="a2a_button_reddit"></IconButton>
          <IconButton component="a" className="a2a_button_pinterest"></IconButton>
        </div>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}></DialogActions>
    </Dialog>
  );
};
